export const flat = (array: any[]): any[] => {
    return array.reduce((acc, curVal) => {
        return acc.concat(curVal);
    }, []);
};

export const isAllTrue = (array: boolean[]): boolean => {
    for (let value of array) {
        if (!value) {
            return false;
        }
    }
    return true;
};

export const shuffleArray = (array: any[]) => {
    for (let i = array.length - 1; i > 0; i--) {
        let j = Math.floor(Math.random() * (i + 1));
        let temp = array[i];
        array[i] = array[j];
        array[j] = temp;
    }
};
